export const EMAIL_CONFIRMED = 'EMAIL_CONFIRMED';
export const ENTER_EMAIL = 'ENTER_EMAIL';
export const INVALID_EMAIL = 'INVALID_EMAIL';
export const INVALID_SECONDARY_EMAIL = 'INVALID_SECONDARY_EMAIL';
export const UNVERIFIED_EMAIL = 'UNVERIFIED_EMAIL';

export const STAGES = [
  ENTER_EMAIL,
  INVALID_EMAIL,
  INVALID_SECONDARY_EMAIL,
  EMAIL_CONFIRMED,
  UNVERIFIED_EMAIL,
];

export const MESSAGES = {
  EMAIL_CONFIRMED: 'login.login.password.recovery.confirmedmail',
  ENTER_EMAIL: 'login.login.password.recovery.entermail',
  INVALID_EMAIL: 'login.login.password.recovery.invalidmail',
  INVALID_SECONDARY_EMAIL: 'login.login.password.recovery.invalidmail.secondary',
  UNVERIFIED_EMAIL: 'verification.verification.continue.text',
};

export const CODES = {
  SECONDARY_EMAIL_CODE: 'pass_rec_secondary_email_error',
  UNVERIFIED_EMAIL_CODE: 'invalid_user_unverified',
};
